export default __webpack_public_path__ + "static/media/bg-ring-2a.5cd99be1.png";